import volunteerRepository from "./volunteerRepository";
import tasksRepository from "./tasksRepository";
import coursesRepository from "./coursesRepository";
import supervisorsRepository from "./supervisorsRepository";
import suggestionsRepository from "./suggestionsRepository";
import availabilityRepository from "./availabilityRepository";
import zadiSessionsRepository from "./zadiSessionsRepository";
import thankYouMessagesRepository from "./thankYouMessagesRepository";

export const repositories = {
  volunteerRepository,
  tasksRepository,
  coursesRepository,
  supervisorsRepository,
  suggestionsRepository,
  availabilityRepository,
  zadiSessionsRepository,
  thankYouMessagesRepository,
};

export const RepositoryFactory = {
  get: name => repositories[name]
};
